const testPhoneNumber = (phoneNumber: string) =>
  phoneNumber === undefined ||
  phoneNumber === null ||
  phoneNumber.length === 0 ||
  /^((((0{2}?)|(\+){1})(45|46|47|358))|0)[\d]{8,}$/.test(phoneNumber)
export default testPhoneNumber
